import React from 'react';
import { UpgradeHoverBarWrapper, ContentWrapper, LinkWrapper } from './styles';
import SVGInline from 'react-svg-inline';
import UpgradeRocketIcon from 'h-commons/images/upgrade-rocket-large.svg';
import SessionedLink from '../SessionedLink';

const UpgradeHoverBar = (props) => {
    const { text, linkText, wrapperStyle, upgradeClickedEvent } = props;
    return (
        <UpgradeHoverBarWrapper style={wrapperStyle}>
            <SVGInline svg={UpgradeRocketIcon} width="30" height="30" />
            <ContentWrapper>
                {text}
                {linkText && (
                    <SessionedLink to="/app/settings/account/upgrade" gainsightEvent={upgradeClickedEvent}>
                        <LinkWrapper>{linkText}</LinkWrapper>
                    </SessionedLink>
                )}
            </ContentWrapper>
        </UpgradeHoverBarWrapper>
    );
};

export default UpgradeHoverBar;
